import {ApiResponse, AppConfig} from 'aegis-api-proxy';
import {AxiosError} from 'axios';
import {Message} from 'element-ui';

const basePath = '/api';

enum HttpStatus {
  forbidden = 403,
  auth = 401,
  serverError = 500
}

export default {
  basePath,
  pathSuffix: '',
  logicErrorHandler: (data: ApiResponse<any>) => {
    if (data.code !== HttpStatus.auth) {
      Message.error(data.msg ?? '出错啦');
    }
    return true;
  },
  httpStatusErrorHandler: (err: AxiosError | any) => {
    if (err.response && err.response.status) {
      const error: AxiosError = err as AxiosError;
      switch (error.response!.status) {
        case HttpStatus.auth:
          // MessageBox.alert('没有访问权限，请刷新页面或重新登录', '访问错误');
          return true;
        case HttpStatus.forbidden:
          return true;
        case HttpStatus.serverError:
          console.log(err.response);
          Message.error(error.response!.data.message);
          return false;
        default:
          // store.commit('error', new Error(err.response.data));
          return false;
      }
    } else {
      Message.error(err.message);
    }
    return false;
  }
} as AppConfig;
